

//automatically generated, do not edit!
//run `node build` instead
module.exports = {
    'convert' : require('./time/convert'),
    'now' : require('./time/now'),
    'parseMs' : require('./time/parseMs'),
    'toTimeString' : require('./time/toTimeString')
};





//////////////////
// WEBPACK FOOTER
// ./~/mout/time.js
// module id = 1684
// module chunks = 0 1 2